export { Testimony } from './testimony';
export type { TestimonyProps } from './testimony';
